// extracted by mini-css-extract-plugin
export default {"Banner":"ProductCardBanner_Banner__E9D7v"};